import controller from './sales-home.controller';
import templateBase from './templates/sales-home-base.view.html';

let SalesHomeComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    /*if (response.BY_FAVORITES.component == 'template_t1') {
        return templateT1;
    } else {*/
    return templateBase;
    //}
}

export default SalesHomeComponent;



// WEBPACK FOOTER //
// ./www/components/sales-home/sales-home.component.js